import React, { useEffect } from 'react'
import AOS from 'aos'
import 'aos/dist/aos.css'
import '../styles/Hero.css' // Make sure this CSS file exists and is correctly styled

const HeroSection = () => {
  useEffect(() => {
    AOS.init({
      duration: 1200, // overall animation duration
    })
  }, [])

  return (
    <>
      <div className='flex mt-40 w-screen z-10 justify-center items-center  absolute'>
        <div data-aos="fade-up" className='mx-auto mt-10 flex justify-center px-4 sm:mt-12 sm:px-6 md:mt-16 lg:mt-20 lg:px-8 bg-gradient-to-t from-transparent to-white py-20 rounded-2xl'>
          <div className='text-center '>
            <h1 className='text-4xl font-extrabold tracking-tight text-gray-900  sm:text-5xl md:text-6xl'>
              <span className='block xl:inline'>
                <span className='mb-1 block'>Simplify your</span>
                <span className='bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent'>
                  Workflow
                </span>
              </span>
              <div className='mt-2'>
                Boost Your
                <span className='relative mt-3 whitespace-nowrap '>
                  <svg
                    aria-hidden='true'
                    viewBox='0 0 418 42'
                    className='absolute top-3/4 left-0 right-0 m-auto h-[0.58em] w-fit fill-pink-400/50'
                    preserveAspectRatio='none'>
                    <path d='M203.371.916c-26.013-2.078-76.686 1.963-124.73 9.946L67.3 12.749C35.421 18.062 18.2 21.766 6.004 25.934 1.244 27.561.828 27.778.874 28.61c.07 1.214.828 1.121 9.595-1.176 9.072-2.377 17.15-3.92 39.246-7.496C123.565 7.986 157.869 4.492 195.942 5.046c7.461.108 19.25 1.696 19.17 2.582-.107 1.183-7.874 4.31-25.75 10.366-21.992 7.45-35.43 12.534-36.701 13.884-2.173 2.308-.202 4.407 4.442 4.734 2.654.187 3.263.157 15.593-.78 35.401-2.686 57.944-3.488 88.365-3.143 46.327.526 75.721 2.23 130.788 7.584 19.787 1.924 20.814 1.98 24.557 1.332l.066-.011c1.201-.203 1.53-1.825.399-2.335-2.911-1.31-4.893-1.604-22.048-3.261-57.509-5.556-87.871-7.36-132.059-7.842-23.239-.254-33.617-.116-50.627.674-11.629.54-42.371 2.494-46.696 2.967-2.359.259 8.133-3.625 26.504-9.81 23.239-7.825 27.934-10.149 28.304-14.005.417-4.348-3.529-6-16.878-7.066Z'></path>
                  </svg>
                  <span className='bg-gradient-to-r from-secondary to-accent bg-clip-text text-transparent '> Productivity</span>
                </span>
              </div>
            </h1>
            <p className='mx-auto mt-3 max-w-xl text-lg text-gray-500  sm:mt-5 md:mt-5'>
              Discover a seamless way to manage your tasks and projects with
              Reflect. Enhance your productivity with our advanced tools and
              intuitive interface.
            </p>
            <div className='mt-5 sm:mt-8 sm:flex sm:justify-center'>
              <div className='rounded-md shadow'>
              <a
        href="#"
        className="font-semibold text-lg px-5 py-3  leading-6 text-white bg-gradient-to-b from-secondary  to-primary rounded-md transition-transform duration-300 transform hover:brightness-90 focus:outline-none focus:shadow-outline"
      >
        Get started now
      </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='relative w-screen h-screen text-white '>
  <div className='absolute top-0 inset-0'>
    <video
      className='w-full h-full object-fill'
      src='https://videos.pexels.com/video-files/9150545/9150545-hd_1920_1080_24fps.mp4'
      type='video/mp4'
      autoPlay
      muted
      loop></video>
    <div className='absolute inset-0 bg-gradient-to-b from-transparent to-white'></div>
  </div>
</div>
    </>
  )
}

export default HeroSection
